'use client';

import Typography from '@mui/material/Typography';
import { buildTitle } from '@/utils/layout';
import config from '@/config';
import Main from '@/components/main';

const CodeOfConductPage = () => {
  return (
    <Main compact>
      <title>{buildTitle('Code of Conduct')}</title>
      <link rel="canonical" href={`${config().universal.baseUri}/code-of-conduct`} />

      <Typography variant="h1">Code of Conduct</Typography>

      <p>In Progress</p>
    </Main>
  );
};

export default CodeOfConductPage;
